import {
    Box,
    Button,
    FormControl,
    Flex,
    Heading,
    ModalCloseButton,
    ModalFooter,
    Checkbox,
  } from "@chakra-ui/react";
  import CalendarInput from "components/addForm/CalendarInput";
  import { CenteredSpinner } from "components/loader/Loader";
  
  const FormExpiryForAll = ({
    handleChange,
    formData,
    handleSubmit,
    disabled,
    isSubmittingForm,
    handleCheckboxChange
  }) => {
    const { expires_on } = formData;
  
    return (
      <>
        <Box>
          <Flex justify="space-between" align="center" mb={1} mt={1}>
            <Heading size="md">Update the expiry date for all properties</Heading>
            <Flex align="center" gap={19}>            
              <ModalCloseButton position="relative" top="0" />
            </Flex>
          </Flex>
          <Flex gap={2}>
            <FormControl flex={1}>
              <CalendarInput
                name="expires_on"
                label="Expiration Date"
                value={expires_on}
                isRequired={true}
                onChange={(e) => handleChange(e)}
                disablePastDate={true}
              />
            </FormControl>
          </Flex>
          <ModalFooter>
            <Flex align="center" justify="space-between" w="100%">
              {/* Checkbox on the left */}
              <Checkbox
                name="update_actual_expiry"
                isChecked={formData.update_actual_expiry}
                onChange={handleCheckboxChange}
              >
                Update actual expiry
              </Checkbox>

              {/* Submit Button on the right */}
              <Button
                background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
                color="#ffffff"
                mr={3}
                onClick={handleSubmit}
                disabled={disabled}
              >
                Update
              </Button>
            </Flex>
          </ModalFooter>
          {isSubmittingForm && <CenteredSpinner />}
        </Box>
      </>
    );
  };
  
  export default FormExpiryForAll;
  